import { connect } from 'react-redux'

export default connect((
  {
    app: {
      data: {
        contents: [
          {
            header = []
          }] = []
      } = {}
    } = {}
  } = {}) => {
  const {
    contents: [
      {
        headerContentBlock = []
      } = {}
    ] = []
  } = header.find(({ '@type': type, contents = []}) =>
    type === 'ContentSlotHeader' &&
      contents.find(({ '@type': type }) => type === 'DesktopPageHeader')
  ) || {}

  const { headerDesktopMainContentTop = []} = headerContentBlock.find(({ '@type': type }) => type === 'HeaderDesktopMainContent') || {}

  const { StoreDetails: { store } = {}} = headerDesktopMainContentTop.find(({ '@type': type }) => type === 'MyStore') || {}

  return store ? { selectedLocation: store } : {}
})
